import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  accounts: [],
  funderAccounts:[],
  totalAccounts: 0,
  totalFunderAccounts:0,
  selectAllField: false,
  selectAllFunderField: false,
  selectedAccounts: [],
  selectedFunderAccount:0,
  selectedAuditAccount:0,
  selectedIslamicForm: 0,
  viewAccount: null,
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
